/*
{
"zoho_crm_id": "${Therapists.Therapist Id}",
"email": "${Therapists.Email}",
"first_name": "${Therapists.First Name}",
"last_name": "${Therapists.Last Name}",
"days": [
    {"start": "${Therapists.Mon Start}", "end": "${Therapists.Mon End}"},
    {"start": "${Therapists.Tue Start}", "end": "${Therapists.Tue End}"},
    {"start": "${Therapists.Wed  Start}", "end": "${Therapists.Wed End}"},
    {"start": "${Therapists.Thu Start}", "end": "${Therapists.Thu End}"},
    {"start": "${Therapists.Fri Start}", "end": "${Therapists.Fri End}"},
    {"start": "${Therapists.Sat Start}", "end": "${Therapists.Sat End}"},
    {"start": "${Therapists.Sun Start}", "end": "${Therapists.Sun End}"}
],
"session_time": "${Therapists.Session Time}",
"max_sessions_per_day": "${Therapists.Max Sessions Per Day}",
"timezone": "${Therapists.Timezones}",
"offers_after_hours": "${Therapists.Offers After Hours}"
}
*/

export const mockData = {
    "/server/api/therapists": {
        GET: [ // WARNING: OLD MOCK DATA. If want to use - check the CRM's webhook structure!
            {
                ROWID: "30083000000013002",
                CREATORID: "30083000000008006",
                CREATEDTIME: "2025-02-01 00:17:45:196",
                MODIFIEDTIME: "2025-02-01 00:17:45:196",
                first_name: "Dr. John",
                zoho_crm_id: null,
                last_name: "Doe",
                email: "webdev@thehartcentre.com.au",
                session_time: 50,
                max_sessions_per_day: 5,
                max_sessions_per_week: 15,
                days: [
                    { start: "11:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" }
                ],
                timezone: "Australia/Sydney",
                offers_after_hours: true,
            },
            {
                ROWID: "30083000000013003",
                CREATORID: "30083000000008006",
                CREATEDTIME: "2025-02-01 00:17:45:196",
                MODIFIEDTIME: "2025-02-01 00:17:45:196",
                first_name: "Dr. John 2",
                zoho_crm_id: null,
                last_name: "Doe",
                email: "johndoe2@example.com",
                session_time: 50,
                max_sessions_per_day: 5,
                max_sessions_per_week: 15,
                days: [
                    { start: "11:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" },
                    { start: "9:00 AM", end: "5:00 PM" }
                ],
                timezone: "Australia/Sydney",
                offers_after_hours: true,
            }
        ],
    },
    "/server/api/events": {
        GET: [
            {
                ROWID: "30083000000012159",
                CREATORID: "30083000000008006",
                CREATEDTIME: "2025-02-01 00:17:45:196",
                MODIFIEDTIME: "2025-02-01 00:17:45:196",
                zoho_crm_id: null,
                therapist_id: "30083000000013002",
                type: "booking",
                time_start: "2025-02-21 11:00:00",
                time_end: "2025-02-21 23:50:00",
                meta: null
            }
        ]
    },
    "server/api/event": {
        POST: {
            success: true,
            data: {
                ROWID: "30083000000012159",
                CREATORID: "30083000000008006",
                CREATEDTIME: "2025-02-01 00:17:45:196",
                MODIFIEDTIME: "2025-02-01 00:17:45:196",
                zoho_crm_id: null,
                therapist_id: "30083000000013002",
                type: "hart_hours",
                time_start: "2025-02-14 14:00:00",
                time_end: "2025-02-14 15:00:00",
                meta: null
            }
        }
    },
    "/server/forms/book": {
        GET: { data: {
            //Therapist: {id, First_Name, Last_Name},
            Therapist: { id: "30083000000013002", First_Name: "Dr. John", Last_Name: "Doe" },
            Time_Start: "18-Mar-2025 02:00 PM",
            isDeposit: true,
            Session_Time: 50,
            In_Person_Or_Online: "Either",
            Client_Balance: 100,
            Price: 200,
            To_Be_Paid: 50,
            Client_Email: "your@email.com",
            Client_Name: "John Doe",
            holdSlot_id: "30083000000012159",
            holdSlot_expireAt: "2025-02-21 23:50:00"
        } }
    }
};
